import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=0fa8c0ec&scoped=true&"
import script from "./LogItem.vue?vue&type=script&lang=js&"
export * from "./LogItem.vue?vue&type=script&lang=js&"
import style0 from "./LogItem.vue?vue&type=style&index=0&id=0fa8c0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8c0ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa8c0ec')) {
      api.createRecord('0fa8c0ec', component.options)
    } else {
      api.reload('0fa8c0ec', component.options)
    }
    module.hot.accept("./LogItem.vue?vue&type=template&id=0fa8c0ec&scoped=true&", function () {
      api.rerender('0fa8c0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScrollView/LogItem.vue"
export default component.exports